<template>
  <div class="fx-no-trans-details">
    <div class="container-content">
      <div class="no-support-content">
        <img src="@/assets/svg/tip_no_support.svg">
        <div class="tip-text" style="font-size: 32px; font-weight: 600">
          {{ $t('tips.feature_not_supported_country')}}
        </div>
        <div class="tip-text">
          {{ $t('tips.try_another_country')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FX_No_Trans_Details'
}
</script>

<style lang="scss" scoped>
.fx-no-trans-details {
  height: calc(100vh - 350px);
  .container-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 300px;

    .no-support-content {
      text-align: center;

      img {
        margin-bottom: 24px;
      }

      .tip-text {
        font-size: 16px;
        color: #898894;
        margin-bottom: 24px;
      }
    }
  }
}
</style>
